import { render, staticRenderFns } from "./CardPropertyDuration.vue?vue&type=template&id=2beb6aab&"
import script from "./CardPropertyDuration.vue?vue&type=script&lang=js&"
export * from "./CardPropertyDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports